import {Directus} from '@directus/sdk';
import {createContext, useContext, useState} from "react";
import {toast} from "react-toastify";

const directus = new Directus(process.env.REACT_APP_API_URL);

const directusContext = createContext({
    directus: directus,
});

const DirectusProvider = (props) => {
    const [version, setVersion] = useState(0);
    const [currentUser, setCurrentUser] = useState(JSON.parse(localStorage.getItem("currentUser")));

    const updateVersion = () => {
        setVersion(version + 1);
    };

    directus.transport.axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        const status = error.response?.status;
        const code = error.response?.data?.errors?.[0]?.extensions?.code;

        const resetCredentials = (msg) => {
            if (msg) {
                toast.dismiss();
                toast.error("Session expirée.");
            }
            localStorage.clear();
            setCurrentUser(null);
            updateVersion();
            this.props.history.push('/login');
        }

        if (status === 401 && code === 'TOKEN_EXPIRED') {
            resetCredentials(true);
        } else if (status === 401 &&
            code === 'INVALID_CREDENTIALS' &&
            error.request.responseURL.includes('refresh') === false &&
            error.request.responseURL.includes('login') === false &&
            error.request.responseURL.includes('tfa') === false) {
            directus.auth.refresh().then((resp) => {
                directus.users.me.read({fields: ["*", "role.*"]}).then((u) => {
                    setCurrentUser(u);
                    return Promise.resolve(
                        directus.transport.axios.request({
                            ...error.config,
                            headers: {
                                Authorization: `Bearer ${resp.access_token}`,
                            },
                        })
                    );
                });
            }).catch(() => {
                resetCredentials(false);
            });
        } else {
            return Promise.reject(error);
        }
    });

    const updateCurrentUser = (u) => {
        localStorage.setItem("currentUser", JSON.stringify(u));
        setCurrentUser(u);
    };

    const value = {
        directus: directus,
        version: version,
        updateVersion: updateVersion,
        currentUser: currentUser,
        setCurrentUser: updateCurrentUser
    };

    return (
        <directusContext.Provider value={value}>
            {props.children}
        </directusContext.Provider>
    );
};

/**
 *
 * @returns Directus
 */
const useDirectus = () => {
    return useContext(directusContext).directus;
}

export {
    DirectusProvider,
    directusContext,
    useDirectus
};
